module.exports = __webpack_public_path__ + "img/70.14260457.jpg";